module.exports = __webpack_public_path__ + "assets/img/gif-2.24eb8442.gif";